import './SonarCardTabs.scss';
import classNames from 'classnames';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { SonarCard } from './SonarCard';
import { Tab } from 'rc-tabs/es/interface';
import { Tabs } from 'antd';
import { useFeatureFlags } from '@hooks';
import React, { useMemo, useState } from 'react';

export interface CardTabOptions extends Tab {
	extra?: React.ReactNode;
	featureFlag?: FeatureFlag;
}

export interface SonarCardTabsProps {
	className?: string;
	defaultKey?: string;
	extra?: React.ReactNode;
	items: Array<CardTabOptions>;
	title: string;
}

export const SonarCardTabs: React.FC<SonarCardTabsProps> = ({ className, defaultKey, extra, items, title }) => {
	const { isEnabled } = useFeatureFlags();

	const managedItems = useMemo(
		() =>
			items.map((item) => ({
				...item,
				disabled: item.featureFlag ? !isEnabled(item.featureFlag) : item.disabled
			})),
		[ isEnabled, items ]
	);

	const [ activeKey, setActiveKey ] = useState(defaultKey ?? managedItems.find((item) => !item.disabled)?.key);

	const activeExtra = managedItems.find((item) => item.key === activeKey)?.extra;

	return (
		<SonarCard
			className={ classNames('sonar-card-tabs', className) }
			extra={ activeExtra === undefined ? extra : activeExtra }
			noSpacing
			title={ title }>
			<Tabs
				activeKey={ activeKey }
				className='sonar-tabs'
				items={ managedItems }
				onChange={ setActiveKey } />
		</SonarCard>
	);
};
